import 'css-chunk:../../src/features/color-picker/components/modal/index.module.scss';export default {
  "picker": "_picker_188z9_1"
};